import { createIconComponent } from './createIconComponent';
import { ReactComponent as Icon } from './resources/search.svg';

export const IconSearch = createIconComponent(Icon);
